import * as React from 'react';
import { cn } from '@/shared/lib/utils';
import { themed } from './themed';

export type NativeSelectProps = React.SelectHTMLAttributes<HTMLSelectElement>;

/** Themed native `<select>` — use for compact/utility dropdowns (e.g. TimePicker).
 *  For user-facing form selects, prefer the Radix-based `Select` from `./select.tsx`. */
export const NativeSelect = React.forwardRef<HTMLSelectElement, NativeSelectProps>(
  ({ className, ...props }, ref) => (
    <select
      ref={ref}
      className={cn(themed.field.base, themed.field.border, themed.focusRing, className)}
      {...props}
    />
  ),
);
NativeSelect.displayName = 'NativeSelect';
